import React from 'react';
import { Trans } from 'react-i18next';
import styles from './TermsOfUse.module.scss';

const TermsOfUse = () => {
  return (
    <Trans i18nKey="TERMS_OF_USE">
      <p>
        Telehealth involves the use of live audio-video electronic communications to deliver health care services to
        patients while the health care provider (the “Provider”) is located at a physical location different from the
        patient receiving the health care services (the “Telehealth Services”). Telehealth Services can improve patient
        care by offering an efficient medical evaluation and improved access to medical care.
      </p>
      <p>
        <strong>By participating in Telehealth Services via the athenaTelehealth tool, I acknowledge that:</strong>
      </p>
      <ol>
        <li>The Provider will be at a different physical location than me.</li>
        <li>
          It is my responsibility to provide accurate, complete, and current information about me and my health
          condition(s) to the Provider while receiving Telehealth Services.
        </li>
        <li>
          I am responsible for all charges (a) that I may incur from my mobile or internet service provider, as
          applicable, when receiving Telehealth Services; and (b) that are not covered by my insurer or third-party
          payor, including any applicable deductibles or co-payments that apply to Telehealth Services. It is my
          responsibility to determine whether my insurance covers Telehealth Services.
        </li>
        <li>
          I can withhold or withdraw consent to receive Telehealth Services at any time without affecting my right to
          future care or treatment, and I may terminate Telehealth Services at any time.
        </li>
        <li>
          The Provider has made reasonable and appropriate efforts to eliminate any confidentiality risks associated
          with Telehealth Services. I am also responsible for mitigating any risks to my privacy or confidentiality
          stemming from the location or circumstances of my participation in Telehealth Services (e.g., joining the
          telehealth encounter from a quiet space, ensuring others do not overhear my conversation or see my computer or
          mobile device screen). All existing confidentiality protections under federal and state law apply to my
          information disclosed during Telehealth Services.
        </li>
        <li>
          The Provider may use, share, or disclose my health information for reimbursement purposes, with other
          healthcare providers for treatment purposes, or for any other purposes in accordance with the Provider’s
          Notices of Privacy Practices and as permitted by applicable law.
        </li>
        <li>
          All existing laws regarding access to my medical information apply to Telehealth Services. All of my medical
          information transmitted during Telehealth Services may be incorporated into my medical record and may be
          provided to other healthcare providers and entities for continuity of care purposes or as otherwise permitted
          under applicable law.
        </li>
        <li>
          There are potential risks to using audio and visual technology for the purpose of a health care visit,
          including, but not limited to, interruptions, unauthorized access, technical difficulties, and call
          termination. I acknowledge and accept those risks, understanding there are alternatives to receiving
          Telehealth Services. Either me or the Provider can discontinue Telehealth Services if either of us determines
          that Telehealth Services are not right for my health care.
        </li>
        <li>
          I understand and acknowledge that Telehealth Services are not intended to be, and do not act as, emergency
          services. If I am experiencing an emergency, I should not rely on Telehealth Services and instead should call
          911.
        </li>
        <li>
          If I have questions or concerns about Telehealth Services, it is my responsibility to contact the Provider. By
          participating in Telehealth Services, I acknowledge and agree that I have had sufficient opportunity to speak
          with the Provider and have no questions or concerns that would preclude me from participating.
        </li>
        <li>
          I understand what it means to receive Telehealth Services and am legally authorized to acknowledge, agree, and
          consent to these athenaTelehealth Terms of Use and Informed Patient Consent (a) on behalf of myself for use of
          Telehealth Services in my medical care, and/or (b) on behalf of any other individual(s) that will be receiving
          Telehealth Services for their medical care during this healthcare encounter.
        </li>
      </ol>
      <em className={styles.emphasis}>
        By joining the telehealth encounter and receiving Telehealth Services through the athenaTelehealth tool, I
        represent that I have read, understand, and agree to these athenaTelehealth Terms of Use and Informed Patient
        Consent; I have been advised of the potential risks, benefits, and alternatives of Telehealth Services; I have
        been given the opportunity to ask questions and have no remaining questions at this time; and I hereby give my
        informed consent for the use of Telehealth Services in my medical care and/or the medical care of the
        individual(s) that will be using Telehealth Services, as applicable.
      </em>
    </Trans>
  );
};

export default TermsOfUse;
